import React, { useEffect, useRef, useState } from 'react';
import { FiCopy } from 'react-icons/fi';
import Layout from '../components/Layout';
import ErrorBoundary from '../components/ErrorBoundary';

const REDIRECT_SERVER_IP = '56.10.19.250';

const ServerIpCopy = () => {
    const [copied, setCopied] = useState(false);
    const timerRef = useRef(null);

    useEffect(() => () => {
        if (timerRef.current) clearTimeout(timerRef.current);
    }, []);

    const handleCopy = () => {
        navigator.clipboard.writeText(REDIRECT_SERVER_IP).then(() => {
            setCopied(true);
            if (timerRef.current) clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <span className="relative inline-flex items-center gap-1 align-middle">
            <strong>{REDIRECT_SERVER_IP}</strong>
            <button
                type="button"
                onClick={handleCopy}
                className="p-0.5 text-gray-500 hover:text-blue-600"
                title="Copy IP"
                aria-label="Copy server IP"
            >
                <FiCopy className="w-4 h-4" />
            </button>
            {copied && (
                <span className="absolute left-1/2 -translate-x-1/2 top-full mt-1 px-2 py-1 bg-gray-800 text-white text-xs font-medium shadow whitespace-nowrap z-10">
                    Copied
                </span>
            )}
        </span>
    );
};

const Step = ({ n, title, children }) => (
    <div className="flex gap-4">
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-blue-600 text-sm font-bold text-white">
            {n}
        </div>
        <div>
            <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
            <div className="mt-1 text-gray-600 space-y-2">{children}</div>
        </div>
    </div>
);

const RedirectHelpPageContent = () => (
    <div className="space-y-6 w-full max-w-3xl px-8 py-6">
        <div className="bg-white rounded-lg shadow p-6 space-y-8">
            <div>
                <h2 className="text-xl font-semibold">Redirect setup</h2>
            </div>

            <Step n="1" title="Point the domain at Cloudflare">
                <p>At the registrar, set the domain’s nameservers to the ones Cloudflare gives for that zone.</p>
            </Step>

            <Step n="2" title="Cloudflare DNS">
                <ul className="list-disc pl-5 space-y-1">
                    <li>Add A record for <code className="text-sm bg-gray-100 px-1 rounded">@</code> → the server ip <ServerIpCopy />.</li>
                    <li>Add A record for <code className="text-sm bg-gray-100 px-1 rounded">www</code> → the server ip <ServerIpCopy />.</li>
                    <li>Proxy status <strong>orange cloud</strong> (proxied), not DNS-only.</li>
                </ul>
            </Step>

            <Step n="3" title="Cloudflare SSL">
                <p>
                    SSL/TLS mode <strong>Full</strong> is enough.
                </p>
            </Step>

            <Step n="4" title="Do not add a Cloudflare Page Rule 302">
                <p>
                    If Cloudflare already have page rules, then request will never reach the server, so analytics/remain path will not run.
                </p>
            </Step>

            <Step n="5" title="Add the domain in ERP">
                <p>
                    in Domain, Create New Entry: Domain (abc.com), destination URL (https://efg.com or a Telegram Link). For Telegram Link , Remain Path checkbox cannot be checked. Changes apply after 60 seconds.
                </p>
            </Step>

            <div className="border-t pt-6 space-y-3">
                <h3 className="text-lg font-semibold">Remain path</h3>
                <p className="text-gray-600">
                    For a website destination, turn on Remain path. Then
                    {' '}
                    <code className="text-sm bg-gray-100 px-1 rounded">abc.com/blog/blog123?utm_source=google</code>
                    {' '}
                    goes to
                    {' '}
                    <code className="text-sm bg-gray-100 px-1 rounded">https://efg.com/blog/blog123?cf_bypass=1&amp;utm_source=google</code>.
                </p>
                <p className="text-gray-600">
                    Telegram destinations (<code className="text-sm bg-gray-100 px-1 rounded">t.me</code>) always use the
                    exact destination URL — no path, no <code className="text-sm bg-gray-100 px-1 rounded">cf_bypass</code>,
                    no extra query.
                </p>
            </div>
        </div>
    </div>
);

const RedirectHelpPage = () => (
    <Layout>
        <ErrorBoundary
            fallbackTitle="Redirect Help Error"
            fallbackDescription="An error occurred while loading Redirect help."
        >
            <RedirectHelpPageContent />
        </ErrorBoundary>
    </Layout>
);

export default RedirectHelpPage;
